import * as React from 'react'
export const TiktokIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.3333 0H2.66667C1.19389 0 0 1.19389 0 2.66667V17.3333C0 18.8061 1.19389 20 2.66667 20H17.3333C18.8061 20 20 18.8061 20 17.3333V2.66667C20 1.19389 18.8061 0 17.3333 0ZM15.7039 8.72778C15.5961 8.73778 15.4868 8.74444 15.3761 8.74444C14.13 8.74444 13.0351 8.10356 12.3979 7.13489V12.6158C12.3979 14.853 10.5841 16.6668 8.347 16.6668C6.10989 16.6668 4.29611 14.853 4.29611 12.6158C4.29611 10.3787 6.10989 8.56489 8.347 8.56489C8.43156 8.56489 8.51422 8.57244 8.59733 8.57767V10.5739C8.51422 10.5639 8.43256 10.5487 8.347 10.5487C7.20489 10.5487 6.27944 11.4741 6.27944 12.6162C6.27944 13.7582 7.20489 14.6836 8.347 14.6836C9.48889 14.6836 10.4976 13.7839 10.4976 12.6418L10.5176 3.33322H12.4254C12.605 5.03922 13.9822 6.38556 15.7039 6.50911V8.72778Z'
        fill='current'
      />
    </svg>
  )
}
